import { getVideo } from "./videoAPI";
import { getLikes } from "./likesAPI";
import { getUnlikes } from "./unlikeAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  video: {},
  isLoading: false,
  isError: false,
  error: "",
};

// async thunk
export const fetchVideo = createAsyncThunk("video/fetchVideo", async (id) => {
  const video = await getVideo(id);
  return video;
});

// async thunk
export const fetchLikes = createAsyncThunk("video/fetchLikes", async (id) => {
  const likes = await getLikes(id);
  return likes;
});

// async thunk
export const fetchUnlikes = createAsyncThunk(
  "video/fetchUnlikes",
  async (id) => {
    const unLikes = await getUnlikes(id);
    return unLikes;
  }
);

const videoSlice = createSlice({
  name: "video",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchVideo.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchVideo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.video = action.payload;
      })
      .addCase(fetchVideo.rejected, (state, action) => {
        state.isLoading = false;
        state.video = {};
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(fetchLikes.pending, (state) => {
        state.isError = false;
        state.isLoading = false;
      })
      .addCase(fetchLikes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.video = action.payload;
      })
      .addCase(fetchLikes.rejected, (state, action) => {
        state.isLoading = false;
        state.video = {};
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(fetchUnlikes.pending, (state) => {
        state.isError = false;
        state.isLoading = false;
      })
      .addCase(fetchUnlikes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.video = action.payload;
      })
      .addCase(fetchUnlikes.rejected, (state, action) => {
        state.isLoading = false;
        state.video = {};
        state.isError = true;
        state.error = action.error?.message;
      });
  },
});

export default videoSlice.reducer;
